import React, { useState } from 'react';
import { IconLock, IconCheck, IconAlert } from './Icons';

interface AuthProps {
  onAuth: (key: string) => void;
}

export const Auth: React.FC<AuthProps> = ({ onAuth }) => {
  const [key, setKey] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!key.trim()) {
      setError('Пожалуйста, введите секретный ключ администратора');
      return;
    }
    onAuth(key);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header-mark">
          <div className="auth-badge-icon">
            <IconLock size={20} />
          </div>
          <span className="auth-system-tag">RESTRICTED ACCESS</span>
        </div>

        <h2 className="auth-title">MIMIC AI КОНСОЛЬ</h2>
        <p className="auth-subtitle">Управление автономной инфраструктурой AI-персон</p>
        
        {error && (
          <div className="alert-box error">
            <IconAlert size={14} />
            <span>{error}</span>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="auth-form-body">
          <div className="form-group">
            <label>СЕКРЕТНЫЙ КЛЮЧ ДОСТУПА:</label>
            <input
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Введите ключ авторизации..."
              autoFocus
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block">
            <IconCheck size={14} />
            <span>АВТОРИЗОВАТЬСЯ</span>
          </button>
        </form>
      </div>
    </div>
  );
};